import { httpCreate } from './http';

const http = httpCreate('/srv/company');

/* 企业版新增 */
export const company = {
	getCompanyInfo() {
		return http.get('');
	},
	getBaseInfo() {
		return http.get('/baseInfo');
	},
	//保存企业基本信息
	saveCompanyInfo(data) {
		return http.post('', data);
	},
	//AI授权次数
	aiEmpower(companyId, data) {
		return http.post(`/aiEmpower/${companyId}`, data);
	},
};
